import loginBackground from "./loginBackground.png";
import mainLogo from "./mainLogo.png";

export const images = {
  loginBackground,
  mainLogo,
};
